import styled from '@emotion/styled';
import JobCardLi, { Props as JobCardProps } from '.';
import Divider from '@components/_atoms/Divider';

const JobCardListUl = styled.ul`
  list-style: none;
  display: flex;
  width: 1080px;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 20px;
  padding-bottom: 20px;
`;

type Props = {
  careerList: JobCardProps[];
};

// TODO : 마감 처리 하기
export default function JobCardList({ careerList }: Props) {
  return (
    <>
      <JobCardListUl>
        {careerList.map((item, index) => (
          <JobCardLi key={index} {...item} />
        ))}
        <Divider />
      </JobCardListUl>
    </>
  );
}
